import {
  CATEGORY,
  PAKAIAN_ATTR,
  SEPATU_ATTR,
  TAS_ATTR,
  AKSESORIS_ATTR,
  MAKE_UP_ATTR } from 'domains/merchant-inbound-item/constants'


const MerchantInboundItemReadCsvService = {

  /**
   * Build payload to validate Merchant Inbound CSV
   * @param {object} file - File csv uploaded
   * @param {string} category - Category choosen to import
   * @return {Promise} Promise object that containt items and isValid
   */
  buildPayload: async (file, category) => {
    let items   = []
    let isValid = true

    // * map the builder by given category
    const buildCategoryMap = {
      [CATEGORY.PAKAIAN]   : buildPakaianItem,
      [CATEGORY.SEPATU]    : buildSepatuItem,
      [CATEGORY.TAS]       : buildTasItem,
      [CATEGORY.AKSESORIS] : buildAksesorisItem,
      [CATEGORY.MAKE_UP]   : buildMakeUpItem
    }
    const buildCategory    = buildCategoryMap[category]

    var reader = new FileReader()
    return new Promise((resolve, reject) => {
      reader.onload = () => {
        // Get File metadata
        var csv        = reader.result
        var lines      = csv.split('\n')
        var headerLine = lines[0]

        /**
         * If it's not valid category, it return:
         * - empty items (items = [])
         * - invalid flag (isValid = false)
         */
        const isValidCategory = validateCategory(lines, category)
        if (!isValidCategory) {
          items   = []
          isValid = false
          resolve([ items, isValid ])
        }
        else {
          const headerIndexesMap = headerIndexMap(headerLine)
          for (var i = 1; i < lines.length - 1; i++) {
            var currentline = lines[i].split(',')

            const item_csv =  buildCategory(headerIndexesMap, currentline)
            items.push(item_csv)
          }

          resolve([ items, isValid ])
        }
      }

      /**
       * If it's not valid category, it return:
       * - empty items (items = [])
       * - invalid flag (isValid = false)
      */
      reader.onerror = () => {
        items   = []
        isValid = false
        reject([ items, isValid ])
      }

      reader.readAsText(file)
    })
  }
}

/**
 * Helper object to validate main_category columns in csv
 */

const validateCategory = (lines, category) => {
  var isValid = true
  for (var i = 2;i < lines.length - 1;i++) {
    var currentline          = lines[i].split(',')
    var column_main_category = currentline[2].toLowerCase()

    /**
    * Exclusively convert category for make_up category
    */
    if (category === 'make_up'){
      category = category.replace('_',' ')
    }

    if (!column_main_category.includes(category)) {
      isValid = false
      break
    }
  }
  return isValid
}

/**
 * Helper object to separete header rows in csv into a Hash
 */

const headerIndexMap = (headerLines) => { // 'No.,Brand Sku,
  const headerNames    = headerLines.split(',') // ['No', 'Brand SKU', 'Main Category', ...]
  const headerIndexMap = new Map()

  for (var indexHeader = 0; indexHeader < headerNames.length; indexHeader++){
    headerIndexMap.set(buildParseableHeader(headerNames[indexHeader]), indexHeader)
  }

  return headerIndexMap
}

/**
 * Helper object to build items for Pakaian category
 */

const buildPakaianItem = (headerIndexesMap, currentline) => ({
  [PAKAIAN_ATTR.BRAND_SKU]           : currentline[headerIndexesMap.get(PAKAIAN_ATTR.BRAND_SKU)],
  [PAKAIAN_ATTR.MAIN_CATEGORY]       : currentline[headerIndexesMap.get(PAKAIAN_ATTR.MAIN_CATEGORY)],
  [PAKAIAN_ATTR.BRAND]               : currentline[headerIndexesMap.get(PAKAIAN_ATTR.BRAND)],
  [PAKAIAN_ATTR.COLOR]               : currentline[headerIndexesMap.get(PAKAIAN_ATTR.COLOR)],
  [PAKAIAN_ATTR.PATTERN]             : currentline[headerIndexesMap.get(PAKAIAN_ATTR.PATTERN)],
  [PAKAIAN_ATTR.FABRIC]              : currentline[headerIndexesMap.get(PAKAIAN_ATTR.FABRIC)],
  [PAKAIAN_ATTR.CONDITION]           : currentline[headerIndexesMap.get(PAKAIAN_ATTR.CONDITION)],
  [PAKAIAN_ATTR.PRICE]               : currentline[headerIndexesMap.get(PAKAIAN_ATTR.PRICE)],
  [PAKAIAN_ATTR.PRODUCT_NAME]        : currentline[headerIndexesMap.get(PAKAIAN_ATTR.PRODUCT_NAME)],
  [PAKAIAN_ATTR.QUANTITY]            : currentline[headerIndexesMap.get(PAKAIAN_ATTR.QUANTITY)],
  [PAKAIAN_ATTR.SIZE]                : currentline[headerIndexesMap.get(PAKAIAN_ATTR.SIZE)],
  [PAKAIAN_ATTR.CHEST_CIRCUMFERENCE] : currentline[headerIndexesMap.get(PAKAIAN_ATTR.CHEST_CIRCUMFERENCE)],
  [PAKAIAN_ATTR.TOP_LENGTH]          : currentline[headerIndexesMap.get(PAKAIAN_ATTR.TOP_LENGTH)],
  [PAKAIAN_ATTR.HIP_CIRCUMFERENCE]   : currentline[headerIndexesMap.get(PAKAIAN_ATTR.HIP_CIRCUMFERENCE)],
  [PAKAIAN_ATTR.TOP_HIP]             : currentline[headerIndexesMap.get(PAKAIAN_ATTR.TOP_HIP)],
  [PAKAIAN_ATTR.WAIST_CIRCUMFERENCE] : currentline[headerIndexesMap.get(PAKAIAN_ATTR.WAIST_CIRCUMFERENCE)],
  [PAKAIAN_ATTR.BOTTOM_LENGTH]       : currentline[headerIndexesMap.get(PAKAIAN_ATTR.BOTTOM_LENGTH)],
  [PAKAIAN_ATTR.WEIGHT]              : currentline[headerIndexesMap.get(PAKAIAN_ATTR.WEIGHT)],
  [PAKAIAN_ATTR.NOTE]                : currentline[headerIndexesMap.get(PAKAIAN_ATTR.NOTE)]
})

/**
 * Helper object to build items for Sepatu category
 */

const buildSepatuItem = (headerIndexesMap, currentline) => ({
  [SEPATU_ATTR.BRAND_SKU]     : currentline[headerIndexesMap.get(SEPATU_ATTR.BRAND_SKU)],
  [SEPATU_ATTR.BRAND]         : currentline[headerIndexesMap.get(SEPATU_ATTR.BRAND)],
  [SEPATU_ATTR.MAIN_CATEGORY] : currentline[headerIndexesMap.get(SEPATU_ATTR.MAIN_CATEGORY)],
  [SEPATU_ATTR.COLOR]         : currentline[headerIndexesMap.get(SEPATU_ATTR.COLOR)],
  [SEPATU_ATTR.PATTERN]       : currentline[headerIndexesMap.get(SEPATU_ATTR.PATTERN)],
  [SEPATU_ATTR.CONDITION]     : currentline[headerIndexesMap.get(SEPATU_ATTR.CONDITION)],
  [SEPATU_ATTR.PRICE]         : currentline[headerIndexesMap.get(SEPATU_ATTR.PRICE)],
  [SEPATU_ATTR.PRODUCT_NAME]  : currentline[headerIndexesMap.get(SEPATU_ATTR.PRODUCT_NAME)],
  [SEPATU_ATTR.QUANTITY]      : currentline[headerIndexesMap.get(SEPATU_ATTR.QUANTITY)],
  [SEPATU_ATTR.SIZE_EU]       : currentline[headerIndexesMap.get(SEPATU_ATTR.SIZE_EU)],
  [SEPATU_ATTR.SIZE_US]       : currentline[headerIndexesMap.get(SEPATU_ATTR.SIZE_US)],
  [SEPATU_ATTR.HEEL_HEIGHT]   : currentline[headerIndexesMap.get(SEPATU_ATTR.HEEL_HEIGHT)],
  [SEPATU_ATTR.BOX]           : currentline[headerIndexesMap.get(SEPATU_ATTR.BOX)],
  [SEPATU_ATTR.DUSTBAG]       : currentline[headerIndexesMap.get(SEPATU_ATTR.DUSTBAG)],
  [SEPATU_ATTR.BOX_LENGTH]    : currentline[headerIndexesMap.get(SEPATU_ATTR.BOX_LENGTH)],
  [SEPATU_ATTR.BOX_WIDTH]     : currentline[headerIndexesMap.get(SEPATU_ATTR.BOX_WIDTH)],
  [SEPATU_ATTR.BOX_HEIGHT]    : currentline[headerIndexesMap.get(SEPATU_ATTR.BOX_HEIGHT)],
  [SEPATU_ATTR.INSOLE]        : currentline[headerIndexesMap.get(SEPATU_ATTR.INSOLE)],
  [SEPATU_ATTR.WEIGHT]        : currentline[headerIndexesMap.get(SEPATU_ATTR.WEIGHT)],
  [SEPATU_ATTR.NOTE]          : currentline[headerIndexesMap.get(SEPATU_ATTR.NOTE)],
  [SEPATU_ATTR.MATERIAL]      : currentline[headerIndexesMap.get(SEPATU_ATTR.MATERIAL)]
})

/**
 * Helper object to build items for Tas category
 */

const buildTasItem = (headerIndexesMap, currentline) => ({
  [TAS_ATTR.BRAND_SKU]         : currentline[headerIndexesMap.get(TAS_ATTR.BRAND_SKU)],
  [TAS_ATTR.MAIN_CATEGORY]     : currentline[headerIndexesMap.get(TAS_ATTR.MAIN_CATEGORY)],
  [TAS_ATTR.BRAND]             : currentline[headerIndexesMap.get(TAS_ATTR.BRAND)],
  [TAS_ATTR.COLOR]             : currentline[headerIndexesMap.get(TAS_ATTR.COLOR)],
  [TAS_ATTR.PATTERN]           : currentline[headerIndexesMap.get(TAS_ATTR.PATTERN)],
  [TAS_ATTR.MATERIAL]          : currentline[headerIndexesMap.get(TAS_ATTR.MATERIAL)],
  [TAS_ATTR.CONDITION]         : currentline[headerIndexesMap.get(TAS_ATTR.CONDITION)],
  [TAS_ATTR.PRICE]             : currentline[headerIndexesMap.get(TAS_ATTR.PRICE)],
  [TAS_ATTR.PRODUCT_NAME]      : currentline[headerIndexesMap.get(TAS_ATTR.PRODUCT_NAME)],
  [TAS_ATTR.QUANTITY]          : currentline[headerIndexesMap.get(TAS_ATTR.QUANTITY)],
  [TAS_ATTR.LENGTH]            : currentline[headerIndexesMap.get(TAS_ATTR.LENGTH)],
  [TAS_ATTR.WIDTH]             : currentline[headerIndexesMap.get(TAS_ATTR.WIDTH)],
  [TAS_ATTR.HEIGHT]            : currentline[headerIndexesMap.get(TAS_ATTR.HEIGHT)],
  [TAS_ATTR.BOX_LENGTH]        : buildParseableValue(currentline[headerIndexesMap.get(TAS_ATTR.BOX_LENGTH)]),
  [TAS_ATTR.BOX_WIDTH]         : buildParseableValue(currentline[headerIndexesMap.get(TAS_ATTR.BOX_WIDTH)]),
  [TAS_ATTR.BOX_HEIGHT]        : buildParseableValue(currentline[headerIndexesMap.get(TAS_ATTR.BOX_HEIGHT)]),
  [TAS_ATTR.STRAP_LENGTH]      : buildParseableValue(currentline[headerIndexesMap.get(TAS_ATTR.STRAP_LENGTH)]),
  [TAS_ATTR.BAG_HANDLE_LENGTH] : buildParseableValue(currentline[headerIndexesMap.get(TAS_ATTR.BAG_HANDLE_LENGTH)]),
  [TAS_ATTR.DUSTBAG]           : currentline[headerIndexesMap.get(TAS_ATTR.DUSTBAG)],
  [TAS_ATTR.CERTIFICATE]       : currentline[headerIndexesMap.get(TAS_ATTR.CERTIFICATE)],
  [TAS_ATTR.WEIGHT]            : currentline[headerIndexesMap.get(TAS_ATTR.WEIGHT)],
  [TAS_ATTR.BOX]               : currentline[headerIndexesMap.get(TAS_ATTR.BOX)],
  [TAS_ATTR.NOTE]              : currentline[headerIndexesMap.get(TAS_ATTR.NOTE)]
})

/**
 * Helper object to build items for Aksesoris category
 */

const buildAksesorisItem = (headerIndexesMap, currentline) => ({
  [AKSESORIS_ATTR.BRAND_SKU]           : currentline[headerIndexesMap.get(AKSESORIS_ATTR.BRAND_SKU)],
  [AKSESORIS_ATTR.MAIN_CATEGORY]       : currentline[headerIndexesMap.get(AKSESORIS_ATTR.MAIN_CATEGORY)],
  [AKSESORIS_ATTR.BRAND]               : currentline[headerIndexesMap.get(AKSESORIS_ATTR.BRAND)],
  [AKSESORIS_ATTR.COLOR]               : currentline[headerIndexesMap.get(AKSESORIS_ATTR.COLOR)],
  [AKSESORIS_ATTR.PATTERN]             : currentline[headerIndexesMap.get(AKSESORIS_ATTR.PATTERN)],
  [AKSESORIS_ATTR.FABRIC]              : currentline[headerIndexesMap.get(AKSESORIS_ATTR.FABRIC)],
  [AKSESORIS_ATTR.CONDITION]           : currentline[headerIndexesMap.get(AKSESORIS_ATTR.CONDITION)],
  [AKSESORIS_ATTR.PRICE]               : currentline[headerIndexesMap.get(AKSESORIS_ATTR.PRICE)],
  [AKSESORIS_ATTR.PRODUCT_NAME]        : currentline[headerIndexesMap.get(AKSESORIS_ATTR.PRODUCT_NAME)],
  [AKSESORIS_ATTR.QUANTITY]            : currentline[headerIndexesMap.get(AKSESORIS_ATTR.QUANTITY)],
  [AKSESORIS_ATTR.LENGTH]              : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.LENGTH)]),
  [AKSESORIS_ATTR.WIDTH]               : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.WIDTH)]),
  [AKSESORIS_ATTR.HEIGHT]              : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.HEIGHT)]),
  [AKSESORIS_ATTR.STRAP_LENGTH]        : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.STRAP_LENGTH)]),
  [AKSESORIS_ATTR.TINY_DIAMETER]       : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.TINY_DIAMETER)]),
  [AKSESORIS_ATTR.BRIDGE_LENGTH]       : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.BRIDGE_LENGTH)]),
  [AKSESORIS_ATTR.LENS_HEIGHT]         : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.LENS_HEIGHT)]),
  [AKSESORIS_ATTR.LENS_WIDTH]          : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.LENS_WIDTH)]),
  [AKSESORIS_ATTR.TEMPLE_LENGTH]       : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.TEMPLE_LENGTH)]),
  [AKSESORIS_ATTR.CHAIN_LENGTH]        : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.CHAIN_LENGTH)]),
  [AKSESORIS_ATTR.TINY_DIAMETER]       : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.TINY_DIAMETER)]),
  [AKSESORIS_ATTR.DIAMETER]            : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.DIAMETER)]),
  [AKSESORIS_ATTR.WRIST_CIRCUMFERENCE] : buildParseableValue(currentline[headerIndexesMap.get(AKSESORIS_ATTR.WRIST_CIRCUMFERENCE)]),
  [AKSESORIS_ATTR.BOX]                 : currentline[headerIndexesMap.get(AKSESORIS_ATTR.BOX)],
  [AKSESORIS_ATTR.WEIGHT]              : currentline[headerIndexesMap.get(AKSESORIS_ATTR.WEIGHT)],
  [AKSESORIS_ATTR.NOTE]                : currentline[headerIndexesMap.get(AKSESORIS_ATTR.NOTE)],
  [AKSESORIS_ATTR.MATERIAL]            : currentline[headerIndexesMap.get(AKSESORIS_ATTR.MATERIAL)]
})

/**
 * Helper object to build items for Aksesoris category
 */

const buildMakeUpItem = (headerIndexesMap, currentline) => ({
  [MAKE_UP_ATTR.BRAND_SKU]           : currentline[headerIndexesMap.get(MAKE_UP_ATTR.BRAND_SKU)],
  [MAKE_UP_ATTR.MAIN_CATEGORY]       : currentline[headerIndexesMap.get(MAKE_UP_ATTR.MAIN_CATEGORY)],
  [MAKE_UP_ATTR.BRAND]               : currentline[headerIndexesMap.get(MAKE_UP_ATTR.BRAND)],
  [MAKE_UP_ATTR.COLOR]               : 'None', // fixed value for make up
  [MAKE_UP_ATTR.MAKE_UP_SIZE]        : currentline[headerIndexesMap.get(MAKE_UP_ATTR.MAKE_UP_SIZE)],
  [MAKE_UP_ATTR.MAKE_UP_FILL]        : currentline[headerIndexesMap.get(MAKE_UP_ATTR.MAKE_UP_FILL)],
  [MAKE_UP_ATTR.MAKE_UP_EXPIRY_DATE] : currentline[headerIndexesMap.get(MAKE_UP_ATTR.MAKE_UP_EXPIRY_DATE)],
  [MAKE_UP_ATTR.CONDITION]           : currentline[headerIndexesMap.get(MAKE_UP_ATTR.CONDITION)],
  [MAKE_UP_ATTR.PRICE]               : currentline[headerIndexesMap.get(MAKE_UP_ATTR.PRICE)],
  [MAKE_UP_ATTR.PRODUCT_NAME]        : currentline[headerIndexesMap.get(MAKE_UP_ATTR.PRODUCT_NAME)],
  [MAKE_UP_ATTR.QUANTITY]            : currentline[headerIndexesMap.get(MAKE_UP_ATTR.QUANTITY)],
  [MAKE_UP_ATTR.WEIGHT]              : currentline[headerIndexesMap.get(MAKE_UP_ATTR.WEIGHT)],
  [MAKE_UP_ATTR.SHADE]               : currentline[headerIndexesMap.get(MAKE_UP_ATTR.SHADE)],
  [MAKE_UP_ATTR.NOTE]                : currentline[headerIndexesMap.get(MAKE_UP_ATTR.NOTE)]
})

/**
 * Helper object to lowercase and remove special character from Csv Header
 */

const buildParseableHeader = (Attribute) => {

  var parseableAttribute = Attribute.toLowerCase().replace('*','')

  /**
  * Switch case to transform some headers from csv to be same as product_attributes
  */
  switch (parseableAttribute) {
    case 'top_chest':
      parseableAttribute = parseableAttribute.replace('top_chest','chest_circumference')
      break
    case 'top_height':
      parseableAttribute = parseableAttribute.replace('top_height','top_length')
      break
    case 'bottom_waist':
      parseableAttribute = parseableAttribute.replace('bottom_waist','waist_circumference')
      break
    case 'bottom_height':
      parseableAttribute = parseableAttribute.replace('bottom_height','bottom_length')
      break
    case 'bottom_hip':
      parseableAttribute = parseableAttribute.replace('bottom_hip','hip_circumference')
      break
    default:
  }

  return parseableAttribute
}

/**
 * Helper object to build remove special character "-" and space from Csv Value
 */

const buildParseableValue = (Attribute) => {
  var parseableAttribute = Attribute
  const matchDigit       = Attribute.match(/\d/)

  if (!matchDigit) {
    parseableAttribute = Attribute.replace('-','').replace(' ','')
  }

  return parseableAttribute
}

export default MerchantInboundItemReadCsvService
